import { Component, Vue } from 'vue-property-decorator';
import { VERSION } from '@/constants';

@Component
export default class Ribbon extends Vue {

  public get displayText(): string {
    var s = this.$store.getters.activeProfiles;
    return 'v' + VERSION + ' - ' + s;
  }

  public get ribbonEnv(): string {
    return this.$store.getters.ribbonOnProfiles;
  }

  public get ribbonEnabled(): boolean {
    if (!this.$store.getters.ribbonOnProfiles) return false;

    let profiles = this.$store.getters.ribbonOnProfiles.split(',');
    let activeProfiles = JSON.stringify(this.$store.getters.activeProfiles);

    for (var profile of profiles) {
      if (activeProfiles.indexOf(profile) > -1) return true;
    }

    return false;
  }
}
